import { useState } from "react"
import ShareList from "../ShareList"

const Share = ({isEvent=false} : {isEvent: boolean}) => {
    const [shareListOpen, setShareListOpen] = useState<boolean>(false)

    return (
        <div className='news-details__share'>
            <button
                style={shareListOpen ? { color: '#7987AC' } : {}}
                onClick={() => setShareListOpen(!shareListOpen)}
                className='news-details__share-button'
            >
                <svg
                    width='38'
                    height='28'
                    viewBox='0 0 38 28'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M24.7068 6L19.7672 11.3196C19.3914 11.7243 19.4148 12.357 19.8195 12.7328C20.2243 13.1086 20.857 13.0852 21.2328 12.6805L26.375 7.14269V9C26.375 9.55229 26.8227 10 27.375 10C27.9273 10 28.375 9.55229 28.375 9V5C28.375 4.44772 27.9273 4 27.375 4L27.0032 4C27.0012 4 26.9993 4 26.9973 4L23 4C22.4477 4 22 4.44772 22 5C22 5.55229 22.4477 6 23 6H24.7068ZM12 8C11.4477 8 11 8.44772 11 9V21C11 21.5523 11.4477 22 12 22H24C24.5523 22 25 21.5523 25 21V15C25 14.4477 25.4477 14 26 14C26.5523 14 27 14.4477 27 15V21C27 22.6569 25.6569 24 24 24H12C10.3431 24 9 22.6569 9 21V9C9 7.34315 10.3431 6 12 6H18C18.5523 6 19 6.44772 19 7C19 7.55229 18.5523 8 18 8H12Z'
                        fill={shareListOpen ? '#7987AC' : '#c1cce2'}
                    />
                </svg>
                Поделиться
            </button>
            <ShareList
                isEvent={isEvent ? true : false}
                shareListOpen={shareListOpen}
                setShareListOpen={state => setShareListOpen(state)}
            />
        </div>
    )
}

export default Share
